module.exports = __webpack_public_path__ + "assets/img/page-header-bg.f4177a8d.png";